export const LIVENESS_CONFIG = Object.freeze({
  confirmationFrames: 4, // 每个动作连续合格帧数；调大更严格，调小更容易通过。
  detectionIntervalMs: 90, // 每隔多少毫秒检测一次。
  timeoutMs: 45_000,
  neutralYawDegrees: 10, // 正脸允许的左右偏差；调大可容忍更歪的正脸。
  neutralPitchDegrees: 10, // 正脸允许的上下偏差；调大可容忍轻微低头/抬头。
  turnThresholdDegrees: 20, // 左右转头至少达到的相对角度；调小更容易通过。
  nodThresholdDegrees: 15, // 低头/抬头至少达到的相对角度；调小更容易通过。
  poseSmoothing: 0.45,
  detectorSampleWidth: 360,
  initializationTimeoutMs: 25_000,
  detectionTimeoutMs: 4_000,
});
